import { Carousel, Image } from "antd";
const Banner = () => {
  return (
    <Carousel autoplay>
      <div>
        <Image
          src="/assets/banners/2.jpg"
          preview={false}
          alt="k"
          //   className="object-cover h-[60vh] w-auto"
        />
      </div>
      <div>
        <Image
          src="/assets/banners/3.jpg"
          preview={false}
          alt="k"
          //   className="object-cover h-[60vh] w-auto"
        />
      </div>
      <div>
        <Image
          src="/assets/banners/4.jpg"
          preview={false}
          alt="k"
          //   className="object-cover h-[60vh] w-auto"
        />
      </div>
    </Carousel>
  );
};
export default Banner;
